import type { ReactNode } from 'react'

import { cn } from '../cn'

export interface PageHeaderProps {
  readonly title: ReactNode
  readonly description?: ReactNode
  readonly actions?: ReactNode
  readonly eyebrow?: ReactNode
  readonly className?: string
}

/** The prototype's `.topbar` + `.page-title`: Fraunces 26 px title, muted sub-line, actions right. */
export function PageHeader({ title, description, actions, eyebrow, className }: PageHeaderProps) {
  return (
    <header
      className={cn('mb-5 flex flex-wrap items-start justify-between gap-x-6 gap-y-3', className)}
    >
      <div className="min-w-0">
        {eyebrow !== undefined && (
          <div className="mb-1 text-[11px] font-bold tracking-[0.06em] text-muted-2 uppercase">
            {eyebrow}
          </div>
        )}
        <h1 className="text-[22px] leading-tight font-semibold sm:text-[26px]">{title}</h1>
        {description !== undefined && (
          <p className="mt-1 max-w-[640px] text-[13px] text-muted">{description}</p>
        )}
      </div>
      {actions !== undefined && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </header>
  )
}
